import { Navigate, createFileRoute, useNavigate } from '@tanstack/react-router'
import { GrowerEditPage } from '@/components/growers/grower-edit-page'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/growers/new',
)({
    component: GrowerCreatePage,
})

function GrowerCreatePage() {
    const navigate = useNavigate()
    const { hasPermission } = useAuth()

    // Không có quyền ghi thì không cho vào trang tạo (kể cả mở thẳng URL).
    if (!hasPermission('growers.write')) {
        return <Navigate to="/agriculture/growers" />
    }

    return (
        <div className="p-6">
            <GrowerEditPage
                mode="create"
                onSaved={(id) =>
                    id
                        ? navigate({
                              to: '/agriculture/growers/$id/edit',
                              params: { id },
                          })
                        : navigate({ to: '/agriculture/growers' })
                }
            />
        </div>
    )
}
